import Vue from 'vue'
import http from '@/common/ajax.js'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ReportData: {},
    StateItemTotal: 0,
    Printing: false,
  },
  mutations: {
    setReportData(state, data) {
      state.ReportData = data
    },
    setStateItemTotal(state, total) {
      state.StateItemTotal = total
    },
    setPrinting(state, printing) {
      state.Printing = printing
    }
  },
  actions: {
    reportData(context, param) {
      const query = {
        ...param,
        contentType: 0,
        reportType: 6,
      }
      http('wx/report/brainwaveAnalyse', query).then(r => {
        // r.jkReportHistories.splice(0,1);
        // let guides = [];
        // for (let i = 0; i < 2; i++) {
        //   guides.push({
        //     ...r.guides[i % 3]
        //   })
        // }
        // r.guides = guides;

        let stateItemTotal = 0;
        ['jkReportHistories', 'qxReportHistories', 'plReportHistories', 'jsReportHistories', 'smReportHistories']
          .forEach(report => {
            (r[report] || []).forEach(item => {
              item.splitpage = stateItemTotal % 2 == 1;
              stateItemTotal++;
            })
          })
        console.log(JSON.parse(JSON.stringify(r)));
        context.commit('setReportData', r);
        context.commit('setStateItemTotal', stateItemTotal);
      })
    }
  },
  modules: {
  }
})
